import React from "react";

const Home = () => {
  return (
    <div className="h-screen w-screen text-3xl font-semibold text-center flex items-center justify-center">
      This is home page, now starts from here
    </div>
  );
};

export default Home;
